import {
  SaveAssessmentActions,
  GetAssessmentDetailsActions,
  ClearFormDetailsActions,
  UploadexcelActions,
  GetActiveAssessmentActions,
} from "./action";

const initState = {
  assessmentSuccessMessage: null,
  assessmentErrorMessage: null,
  assessmentStatus: null,
  assessmentMaster: [],
  assessmentData: null,
  ActiveAssessmentList: null,
};

export default function AddAssessment(state = initState, { type, payload }) {
  switch (type) {
    case SaveAssessmentActions.SAVE_ASSESSMENT:
      return {
        ...state,
        isLoading: true,
        assessmentErrorMessage: null,
        modalActive: false,
      };
    case SaveAssessmentActions.SAVE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: true,
        isLoading: false,
        assessmentStatus: payload.status,
        assessmentErrorMessage: null,
        assessmentSuccessMessage: "Assessment added successfully!",
      };

    case SaveAssessmentActions.SAVE_ASSESSMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        assessmentStatus: null,
        assessmentErrorMessage: payload,
      };
    case SaveAssessmentActions.SAVE_ASSESSMENT_STATUS:
      return {
        ...state,
        assessmentStatus: 0,
        assessmentErrorMessage: null,
      };

    ///////////////////////////////////////////////////////
    // GET  BY ID
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS:
      return {
        ...state,
        isLoading: true,
        assessmentErrorMessage: null,
        modalActive: false,
        assessmentData: null,
      };
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        assessmentData: payload.data,
        assessmentErrorMessage: null,
      };
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        assessmentErrorMessage: payload,
        assessmentData: null,
      };
    case GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_STATUS:
      return {
        ...state,
        assessmentData: null,
      };
    ///Active ASSESSMENT
    case GetActiveAssessmentActions.FETCH_ACTIVE_DATA_DISPOSAL:
      return {
        ...state,
        isLoading: true,
        assessmentErrorMessage: null,
        modalActive: false,
        ActiveAssessmentList: null,
      };
    case GetActiveAssessmentActions.FETCH_ACTIVE_DATA_DISPOSAL_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        ActiveAssessmentList: payload.data,
        assessmentErrorMessage: null,
      };
    case GetActiveAssessmentActions.FETCH_ACTIVE_DATA_DISPOSAL_REJECTED:
      return {
        ...state,
        isLoading: false,
        assessmentErrorMessage: payload,
        ActiveAssessmentList: null,
      };
    case GetActiveAssessmentActions.FETCH_ACTIVE_DATA_DISPOSAL_STATUS:
      return {
        ...state,
        ActiveAssessmentList: null,
      };
    // clear assetType details
    case ClearFormDetailsActions.CLEAR_FORM_DETAILS:
      return {
        ...state,
        Getassessment: null,
        assessmentStatus: null,
        assessmentSuccessMessage: null,
        GetassessmentStatus: null,
        assessmentData: null,
      };

    /*Excel Actions */

    // case UploadexcelActions.CREATE_UPLOAD_EXCEL:
    //   return {
    //     ...state,
    //   };
    // case UploadexcelActions.CREATE_UPLOAD_EXCEL_SUCCESS:
    //   console.log(payload);
    //   return {
    //     ...state,
    //     ItineraryImage: payload.data,
    //     ItineraryStatus: payload.status,
    //   };
    // case UploadexcelActions.CREATE_UPLOAD_EXCEL_FAILURE:
    //   // error = payload || { message: payload.message };//2nd one is network or server down errors
    //   return {
    //     ...state,
    //     errorMessage: payload,
    //   };
    /* */

    default:
      return state;
  }
}
